import { render } from "./ChordsComponent.vue?vue&type=template&id=f43615ac&scoped=true"
import script from "./ChordsComponent.vue?vue&type=script&lang=ts"
export * from "./ChordsComponent.vue?vue&type=script&lang=ts"

import "./ChordsComponent.vue?vue&type=style&index=0&id=f43615ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f43615ac"

export default script